<template>
    <div>
        <table class="table table-responsive table-bordered">
            <thead class="thead-dark">
                <tr>
                    <th v-for="column in columns">{{column}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><input type="text"></td>
                    <td><input type="text"></td>
                    <td><input type="text"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "tablaPie",
        data(){
            return{
                columns:['Neto','Iva','Total']
            }
        }
    }
</script>

<style scoped>

</style>
